import { TLanguagesState } from 'mph-helper';
import { http } from '@/http';

export class LanguagesService {
  static getLanguages(): Promise<TLanguagesState['languages']> {
    return http.get('/commons/languages')
      .then(({ data }) => data);
  }
}
